import React, { useMemo, useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import Ventilators from "./Ventilators";
import { useOktaAuth } from "@okta/okta-react";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import NotFound from "../../Alerts/NotFound";
import VentilatorsByHospitals from "./VentilatorsByHospitals";

const useStyles = makeStyles({
  root: {
    height: "30px",
    color: "rgb(8,87,97)",
  },
  text: {
    marginLeft: "-20px",
    fontWeight: "bold",
    fontSize: "30px",
  },
  icon: {
    color: "rgb(8,87,97)",
    marginLeft: "-10px",
  },
});

export default function Ppe() {
  const [data, setData] = useState([]);
  const [hospitalData, setHospitalData] = useState([]);
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState("");
  const classes = useStyles();

  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      setUserInfo(null);
    } else {
      oktaAuth.getUser().then((info) => {
        setUserInfo(info.groups);
      });
    }
  }, [authState, oktaAuth]);

  const getData = () => {
    (async () => {
      const result = await fetch("ppeTestData.json", {
        method: "GET",
        headers: {
          // Authorization:'weoifjg0924gjwgj',
          "Content-Type": "application/json",
        },
      });
      const names = await result.json();
      setData(names.VentilatorsUsage);
      setHospitalData(names.VentilatorsByHospital);
      // console.log(names.per_hospital_summary)
    })();
  };

  const updateTime = () => {
    var current = new Date();
    return current.toLocaleString();
  };

  useEffect(() => {
    getData();

    const interval = setInterval(() => {
      getData();
      updateTime();
    }, 100000);

    return () => clearInterval(interval);
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "Hospital Name",
        accessor: "HospitalName",
      },
      {
        Header: "Total Ventilators",
        accessor: "TotalVentilators",
      },
      {
        Header: "Ventilators In Use",
        accessor: "VentilatorsInUse",
      },
      {
        Header: "Ventilators used for Covid 19",
        accessor: "VentilatorsUsedByCovid19",
      },
      {
        Header: "N95 Supply(days)",
        accessor: "N95Supply",
      },
      {
        Header: "Other PPE Supply(days)",
        accessor: "OtherSupply",
      },
      {
        Header: "Last Updated By Facility",
        accessor: "LastUpdated",
      },
    ],
    []
  );

  const handleGroupAuth = (str) => {
    return userInfo && userInfo.indexOf(str) !== -1;
  };

  if (handleGroupAuth("Nebraska PPE Dashboard Users")) {
  return (
    <div>
      <div className="mt-5 pt-4">
        <ListItem className={classes.root}>
          <ListItemIcon>
            <AddLocationIcon fontSize="large" className={classes.icon} />
          </ListItemIcon>
          <ListItemText disableTypography>
            <span className={classes.text}>PPE Dashboard</span>
            <div className="d-inline">
              <span className=" ml-3"> Last Updated : {updateTime()}</span>
            </div>
          </ListItemText>
        </ListItem>
        <div className="alert alert-light mt-3" role="alert">
          Data Provided for Ventilators is provided by the Omaha Healthcae
          Coalition and is current as 07/26/2020.
        </div>
      </div>
      <Paper elevation={0} style={{ padding: "10px", marginBottom: "20px" }}>
        <Ventilators data={data} />
      </Paper>
      <Paper elevation={2} style={{ padding: "8px" }}>
        <VentilatorsByHospitals columns={columns} data={hospitalData} />
      </Paper>

      <div className="alert alert-light mt-4" role="alert">
        Disclaimer: Disclosure of identifiable health information is made
        pursuant to Nebraska Executive Order No. 20-15 and the federal HHS{" "}
        <a href="https://www.hhs.gov/sites/default/files/notification-enforcement-discretion-hipaa.pdf?language=es">
          Notification of Enforcement Discretion under HIPAA{" "}
        </a>
        , as such use is made to individuals who are in a position to prevent
        and lessen a serious and imminent threat to the health and safety of a
        person or the public.
      </div>
    </div>
  )} else {
    return (<NotFound/>)
  }
}
